module.exports = __webpack_public_path__ + "img/unicarriers.b12a7f57.svg";